import React from "react";
import { useSelector } from "react-redux";
import LocalNavMenu from "../LocalNavMenu";
import LocalNavSoftLink from "../LocalNavSoftLink";
import LocalNavHardLink from "../LocalNavHardLink";

export default function ReportsMenu() {
    const pathname = useSelector(state => state.router.location.pathname);
    const companyId = useSelector(state => state.session.companyId);
    const hasCompanySelected = companyId != null && companyId > 0;

    if (!hasCompanySelected) return null;

    const audienceDiscoveryName = "Audience Insights";
    const reportPaths = ["/Tableau/Tableau3", "/LayoutsMain/History"];
    const isActive = pathname.includes("/reports/") || reportPaths.some(p => pathname.includes(p));

    return (
        <li id="reports" className={`menu-li ${isActive ? "active" : ""}`}>
            <LocalNavMenu
                id="reports-menu"
                key="reports"
                text="Reports"
                isCollapsed
                collapsedIcon="/Images/Icons/documents.png"
            >
                <LocalNavSoftLink
                    id="activity-reports"
                    destination="/reports/activity-reports"
                    text="Activity Reports"
                    removeLi={true}
                />
                <LocalNavHardLink
                    id="discovery-reports"
                    destination="/ae/reports/tableau-discovery-reports"
                    text={audienceDiscoveryName}
                    feature="audience-insights-reports"
                    removeLi={true}
                />
                <LocalNavHardLink
                    id="custom-reports"
                    destination="/ae/reports/tableau-custom-reports"
                    text="Custom Reports"
                    feature="tableau-reports"
                    removeLi={true}
                />
            </LocalNavMenu>
        </li>
    );
}
